/* eslint-disable */
// AUTO-GENERATED FILE. DO NOT EDIT.
// Source: lum-agentic-ai-backend/packages/api/src/docs/openapiContracts.ts
// Regenerate with: pnpm --filter @lum/web generate:api

export const openApiOperations = [
  {
    "key": "POST /api/v1/auth/accept-invitation",
    "method": "POST",
    "route": "/api/v1/auth/accept-invitation"
  },
  {
    "key": "GET /api/v1/admin/invitations",
    "method": "GET",
    "route": "/api/v1/admin/invitations"
  },
  {
    "key": "POST /api/v1/admin/invitations/{id}/reveal",
    "method": "POST",
    "route": "/api/v1/admin/invitations/{id}/reveal"
  },
  {
    "key": "DELETE /api/v1/admin/invitations/{id}",
    "method": "DELETE",
    "route": "/api/v1/admin/invitations/{id}"
  },
  {
    "key": "GET /api/v1/users/me/product-updates",
    "method": "GET",
    "route": "/api/v1/users/me/product-updates"
  },
  {
    "key": "PATCH /api/v1/users/me/product-updates",
    "method": "PATCH",
    "route": "/api/v1/users/me/product-updates"
  },
  {
    "key": "DELETE /api/v1/notifications/clear-all",
    "method": "DELETE",
    "route": "/api/v1/notifications/clear-all"
  },
  {
    "key": "PATCH /api/v1/tenders/{id}/documents/{documentId}/matching-scope",
    "method": "PATCH",
    "route": "/api/v1/tenders/{id}/documents/{documentId}/matching-scope"
  },
  {
    "key": "DELETE /api/v1/criteria-requirements/onedrive/connection",
    "method": "DELETE",
    "route": "/api/v1/criteria-requirements/onedrive/connection"
  },
  {
    "key": "GET /api/v1/criteria-requirements/sharepoint/drives",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/sharepoint/drives"
  },
  {
    "key": "GET /api/v1/criteria-requirements/sharepoint/drives/{driveId}/children",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/sharepoint/drives/{driveId}/children"
  },
  {
    "key": "GET /api/v1/criteria-requirements/analyses/{id}/source-preview",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/analyses/{id}/source-preview"
  },
  {
    "key": "GET /api/v1/criteria-requirements/analyses/{id}/source",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/analyses/{id}/source"
  },
  {
    "key": "GET /api/v1/criteria-requirements/analyses/{id}/download",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/analyses/{id}/download"
  },
  {
    "key": "GET /api/v1/event-intelligence/profiles",
    "method": "GET",
    "route": "/api/v1/event-intelligence/profiles"
  },
  {
    "key": "GET /api/v1/event-intelligence/team",
    "method": "GET",
    "route": "/api/v1/event-intelligence/team"
  },
  {
    "key": "PUT /api/v1/event-intelligence/profiles/company",
    "method": "PUT",
    "route": "/api/v1/event-intelligence/profiles/company"
  },
  {
    "key": "POST /api/v1/event-intelligence/profiles/personnel",
    "method": "POST",
    "route": "/api/v1/event-intelligence/profiles/personnel"
  },
  {
    "key": "PATCH /api/v1/event-intelligence/profiles/{id}",
    "method": "PATCH",
    "route": "/api/v1/event-intelligence/profiles/{id}"
  },
  {
    "key": "DELETE /api/v1/event-intelligence/profiles/{id}",
    "method": "DELETE",
    "route": "/api/v1/event-intelligence/profiles/{id}"
  },
  {
    "key": "GET /api/v1/event-intelligence/runs",
    "method": "GET",
    "route": "/api/v1/event-intelligence/runs"
  },
  {
    "key": "POST /api/v1/event-intelligence/discover",
    "method": "POST",
    "route": "/api/v1/event-intelligence/discover"
  },
  {
    "key": "GET /api/v1/event-intelligence/opportunities",
    "method": "GET",
    "route": "/api/v1/event-intelligence/opportunities"
  },
  {
    "key": "GET /api/v1/event-intelligence/opportunities/summary",
    "method": "GET",
    "route": "/api/v1/event-intelligence/opportunities/summary"
  },
  {
    "key": "POST /api/v1/event-intelligence/opportunities",
    "method": "POST",
    "route": "/api/v1/event-intelligence/opportunities"
  },
  {
    "key": "GET /api/v1/event-intelligence/opportunities/{id}",
    "method": "GET",
    "route": "/api/v1/event-intelligence/opportunities/{id}"
  },
  {
    "key": "PATCH /api/v1/event-intelligence/opportunities/{id}",
    "method": "PATCH",
    "route": "/api/v1/event-intelligence/opportunities/{id}"
  },
  {
    "key": "DELETE /api/v1/event-intelligence/opportunities/{id}",
    "method": "DELETE",
    "route": "/api/v1/event-intelligence/opportunities/{id}"
  },
  {
    "key": "GET /api/v1/proposal-drafts/leads/{leadId}",
    "method": "GET",
    "route": "/api/v1/proposal-drafts/leads/{leadId}"
  },
  {
    "key": "POST /api/v1/proposal-drafts/leads/{leadId}",
    "method": "POST",
    "route": "/api/v1/proposal-drafts/leads/{leadId}"
  },
  {
    "key": "GET /api/v1/proposal-drafts/{draftId}",
    "method": "GET",
    "route": "/api/v1/proposal-drafts/{draftId}"
  },
  {
    "key": "PATCH /api/v1/proposal-drafts/{draftId}/sections/{sectionId}",
    "method": "PATCH",
    "route": "/api/v1/proposal-drafts/{draftId}/sections/{sectionId}"
  },
  {
    "key": "PATCH /api/v1/proposal-drafts/{draftId}/compliance/{itemId}",
    "method": "PATCH",
    "route": "/api/v1/proposal-drafts/{draftId}/compliance/{itemId}"
  },
  {
    "key": "POST /api/v1/proposal-drafts/{draftId}/sections/{sectionId}/regenerate",
    "method": "POST",
    "route": "/api/v1/proposal-drafts/{draftId}/sections/{sectionId}/regenerate"
  },
  {
    "key": "POST /api/v1/proposal-drafts/{draftId}/quality-review",
    "method": "POST",
    "route": "/api/v1/proposal-drafts/{draftId}/quality-review"
  },
  {
    "key": "GET /api/v1/tenders/{id}/documents",
    "method": "GET",
    "route": "/api/v1/tenders/{id}/documents"
  },
  {
    "key": "POST /api/v1/tenders/{id}/documents",
    "method": "POST",
    "route": "/api/v1/tenders/{id}/documents"
  },
  {
    "key": "DELETE /api/v1/tenders/{id}/documents/{documentId}",
    "method": "DELETE",
    "route": "/api/v1/tenders/{id}/documents/{documentId}"
  },
  {
    "key": "GET /api/v1/evidence/repositories",
    "method": "GET",
    "route": "/api/v1/evidence/repositories"
  },
  {
    "key": "POST /api/v1/evidence/repositories",
    "method": "POST",
    "route": "/api/v1/evidence/repositories"
  },
  {
    "key": "PATCH /api/v1/evidence/repositories/{id}",
    "method": "PATCH",
    "route": "/api/v1/evidence/repositories/{id}"
  },
  {
    "key": "DELETE /api/v1/evidence/repositories/{id}",
    "method": "DELETE",
    "route": "/api/v1/evidence/repositories/{id}"
  },
  {
    "key": "POST /api/v1/evidence/repositories/{id}/reindex",
    "method": "POST",
    "route": "/api/v1/evidence/repositories/{id}/reindex"
  },
  {
    "key": "GET /api/v1/evidence/documents",
    "method": "GET",
    "route": "/api/v1/evidence/documents"
  },
  {
    "key": "PATCH /api/v1/evidence/documents/{id}",
    "method": "PATCH",
    "route": "/api/v1/evidence/documents/{id}"
  },
  {
    "key": "GET /api/v1/evidence/leads/{leadId}",
    "method": "GET",
    "route": "/api/v1/evidence/leads/{leadId}"
  },
  {
    "key": "GET /api/v1/evidence/leads/{leadId}/status",
    "method": "GET",
    "route": "/api/v1/evidence/leads/{leadId}/status"
  },
  {
    "key": "GET /api/v1/evidence/leads/{leadId}/history",
    "method": "GET",
    "route": "/api/v1/evidence/leads/{leadId}/history"
  },
  {
    "key": "POST /api/v1/evidence/leads/{leadId}/run",
    "method": "POST",
    "route": "/api/v1/evidence/leads/{leadId}/run"
  },
  {
    "key": "POST /api/v1/evidence/leads/{leadId}/requirements/{requirementId}/matches",
    "method": "POST",
    "route": "/api/v1/evidence/leads/{leadId}/requirements/{requirementId}/matches"
  },
  {
    "key": "DELETE /api/v1/evidence/leads/{leadId}/matches/{matchId}",
    "method": "DELETE",
    "route": "/api/v1/evidence/leads/{leadId}/matches/{matchId}"
  },
  {
    "key": "PATCH /api/v1/evidence/leads/{leadId}/matches/{matchId}/score",
    "method": "PATCH",
    "route": "/api/v1/evidence/leads/{leadId}/matches/{matchId}/score"
  },
  {
    "key": "GET /api/v1/experts",
    "method": "GET",
    "route": "/api/v1/experts"
  },
  {
    "key": "GET /api/v1/experts/{id}",
    "method": "GET",
    "route": "/api/v1/experts/{id}"
  },
  {
    "key": "PATCH /api/v1/experts/{id}",
    "method": "PATCH",
    "route": "/api/v1/experts/{id}"
  },
  {
    "key": "GET /api/v1/experts/leads/{leadId}/status",
    "method": "GET",
    "route": "/api/v1/experts/leads/{leadId}/status"
  },
  {
    "key": "GET /api/v1/experts/leads/{leadId}/results",
    "method": "GET",
    "route": "/api/v1/experts/leads/{leadId}/results"
  },
  {
    "key": "GET /api/v1/experts/leads/{leadId}/history",
    "method": "GET",
    "route": "/api/v1/experts/leads/{leadId}/history"
  },
  {
    "key": "POST /api/v1/experts/leads/{leadId}/compare",
    "method": "POST",
    "route": "/api/v1/experts/leads/{leadId}/compare"
  },
  {
    "key": "POST /api/v1/experts/leads/{leadId}/run",
    "method": "POST",
    "route": "/api/v1/experts/leads/{leadId}/run"
  },
  {
    "key": "POST /api/v1/experts/leads/{leadId}/recommendations/{recommendationId}/reject",
    "method": "POST",
    "route": "/api/v1/experts/leads/{leadId}/recommendations/{recommendationId}/reject"
  },
  {
    "key": "POST /api/v1/experts/leads/{leadId}/selections",
    "method": "POST",
    "route": "/api/v1/experts/leads/{leadId}/selections"
  },
  {
    "key": "PATCH /api/v1/experts/leads/{leadId}/selections/{selectionId}",
    "method": "PATCH",
    "route": "/api/v1/experts/leads/{leadId}/selections/{selectionId}"
  },
  {
    "key": "DELETE /api/v1/experts/leads/{leadId}/selections/{selectionId}",
    "method": "DELETE",
    "route": "/api/v1/experts/leads/{leadId}/selections/{selectionId}"
  },
  {
    "key": "POST /api/v1/experts/leads/{leadId}/team/confirm",
    "method": "POST",
    "route": "/api/v1/experts/leads/{leadId}/team/confirm"
  },
  {
    "key": "GET /api/v1/experts/leads/{leadId}/team",
    "method": "GET",
    "route": "/api/v1/experts/leads/{leadId}/team"
  },
  {
    "key": "GET /api/v1/experts/leads/{leadId}/proposal-team",
    "method": "GET",
    "route": "/api/v1/experts/leads/{leadId}/proposal-team"
  },
  {
    "key": "POST /api/v1/auth/login",
    "method": "POST",
    "route": "/api/v1/auth/login"
  },
  {
    "key": "POST /api/v1/auth/csrf",
    "method": "POST",
    "route": "/api/v1/auth/csrf"
  },
  {
    "key": "POST /api/v1/auth/refresh",
    "method": "POST",
    "route": "/api/v1/auth/refresh"
  },
  {
    "key": "POST /api/v1/auth/logout",
    "method": "POST",
    "route": "/api/v1/auth/logout"
  },
  {
    "key": "POST /api/v1/auth/logout-all",
    "method": "POST",
    "route": "/api/v1/auth/logout-all"
  },
  {
    "key": "POST /api/v1/auth/logout-other-sessions",
    "method": "POST",
    "route": "/api/v1/auth/logout-other-sessions"
  },
  {
    "key": "GET /api/v1/auth/sessions",
    "method": "GET",
    "route": "/api/v1/auth/sessions"
  },
  {
    "key": "POST /api/v1/auth/sessions/{sessionId}/revoke",
    "method": "POST",
    "route": "/api/v1/auth/sessions/{sessionId}/revoke"
  },
  {
    "key": "GET /api/v1/auth/me",
    "method": "GET",
    "route": "/api/v1/auth/me"
  },
  {
    "key": "POST /api/v1/auth/change-password",
    "method": "POST",
    "route": "/api/v1/auth/change-password"
  },
  {
    "key": "POST /api/v1/auth/forgot-password",
    "method": "POST",
    "route": "/api/v1/auth/forgot-password"
  },
  {
    "key": "POST /api/v1/auth/reset-password",
    "method": "POST",
    "route": "/api/v1/auth/reset-password"
  },
  {
    "key": "POST /api/v1/auth/mfa/setup",
    "method": "POST",
    "route": "/api/v1/auth/mfa/setup"
  },
  {
    "key": "POST /api/v1/auth/mfa/enable",
    "method": "POST",
    "route": "/api/v1/auth/mfa/enable"
  },
  {
    "key": "POST /api/v1/auth/mfa/disable",
    "method": "POST",
    "route": "/api/v1/auth/mfa/disable"
  },
  {
    "key": "GET /api/v1/users",
    "method": "GET",
    "route": "/api/v1/users"
  },
  {
    "key": "POST /api/v1/users",
    "method": "POST",
    "route": "/api/v1/users"
  },
  {
    "key": "GET /api/v1/users/{id}",
    "method": "GET",
    "route": "/api/v1/users/{id}"
  },
  {
    "key": "PATCH /api/v1/users/{id}",
    "method": "PATCH",
    "route": "/api/v1/users/{id}"
  },
  {
    "key": "PATCH /api/v1/users/me/profile",
    "method": "PATCH",
    "route": "/api/v1/users/me/profile"
  },
  {
    "key": "PATCH /api/v1/users/me/name",
    "method": "PATCH",
    "route": "/api/v1/users/me/name"
  },
  {
    "key": "GET /api/v1/users/me/digest-settings",
    "method": "GET",
    "route": "/api/v1/users/me/digest-settings"
  },
  {
    "key": "GET /api/v1/users/me/onboarding/dashboard",
    "method": "GET",
    "route": "/api/v1/users/me/onboarding/dashboard"
  },
  {
    "key": "PATCH /api/v1/users/me/dashboard-layout",
    "method": "PATCH",
    "route": "/api/v1/users/me/dashboard-layout"
  },
  {
    "key": "GET /api/v1/users/me/onboarding/pages/{pageId}",
    "method": "GET",
    "route": "/api/v1/users/me/onboarding/pages/{pageId}"
  },
  {
    "key": "PATCH /api/v1/users/me/onboarding/pages/{pageId}",
    "method": "PATCH",
    "route": "/api/v1/users/me/onboarding/pages/{pageId}"
  },
  {
    "key": "PATCH /api/v1/users/me/onboarding/dashboard",
    "method": "PATCH",
    "route": "/api/v1/users/me/onboarding/dashboard"
  },
  {
    "key": "PATCH /api/v1/users/me/digest-settings",
    "method": "PATCH",
    "route": "/api/v1/users/me/digest-settings"
  },
  {
    "key": "GET /api/v1/tenders",
    "method": "GET",
    "route": "/api/v1/tenders"
  },
  {
    "key": "DELETE /api/v1/tenders",
    "method": "DELETE",
    "route": "/api/v1/tenders"
  },
  {
    "key": "DELETE /api/v1/tenders/selected",
    "method": "DELETE",
    "route": "/api/v1/tenders/selected"
  },
  {
    "key": "GET /api/v1/tenders/crawler-status",
    "method": "GET",
    "route": "/api/v1/tenders/crawler-status"
  },
  {
    "key": "GET /api/v1/tenders/{id}",
    "method": "GET",
    "route": "/api/v1/tenders/{id}"
  },
  {
    "key": "DELETE /api/v1/tenders/{id}",
    "method": "DELETE",
    "route": "/api/v1/tenders/{id}"
  },
  {
    "key": "PATCH /api/v1/tenders/{id}",
    "method": "PATCH",
    "route": "/api/v1/tenders/{id}"
  },
  {
    "key": "POST /api/v1/tenders/trigger-crawl",
    "method": "POST",
    "route": "/api/v1/tenders/trigger-crawl"
  },
  {
    "key": "POST /api/v1/tenders/{id}/verify",
    "method": "POST",
    "route": "/api/v1/tenders/{id}/verify"
  },
  {
    "key": "POST /api/v1/tenders/{id}/extract-questions",
    "method": "POST",
    "route": "/api/v1/tenders/{id}/extract-questions"
  },
  {
    "key": "POST /api/v1/tenders/{id}/draft-answers",
    "method": "POST",
    "route": "/api/v1/tenders/{id}/draft-answers"
  },
  {
    "key": "GET /api/v1/leads",
    "method": "GET",
    "route": "/api/v1/leads"
  },
  {
    "key": "DELETE /api/v1/leads",
    "method": "DELETE",
    "route": "/api/v1/leads"
  },
  {
    "key": "DELETE /api/v1/leads/selected",
    "method": "DELETE",
    "route": "/api/v1/leads/selected"
  },
  {
    "key": "POST /api/v1/leads",
    "method": "POST",
    "route": "/api/v1/leads"
  },
  {
    "key": "GET /api/v1/leads/{id}",
    "method": "GET",
    "route": "/api/v1/leads/{id}"
  },
  {
    "key": "POST /api/v1/leads/{id}/enrich",
    "method": "POST",
    "route": "/api/v1/leads/{id}/enrich"
  },
  {
    "key": "PATCH /api/v1/leads/{id}",
    "method": "PATCH",
    "route": "/api/v1/leads/{id}"
  },
  {
    "key": "POST /api/v1/leads/{id}/activities",
    "method": "POST",
    "route": "/api/v1/leads/{id}/activities"
  },
  {
    "key": "POST /api/v1/leads/{id}/timeline",
    "method": "POST",
    "route": "/api/v1/leads/{id}/timeline"
  },
  {
    "key": "PATCH /api/v1/leads/{id}/timeline/{taskId}",
    "method": "PATCH",
    "route": "/api/v1/leads/{id}/timeline/{taskId}"
  },
  {
    "key": "DELETE /api/v1/leads/{id}/timeline/{taskId}",
    "method": "DELETE",
    "route": "/api/v1/leads/{id}/timeline/{taskId}"
  },
  {
    "key": "POST /api/v1/leads/{id}/zoho",
    "method": "POST",
    "route": "/api/v1/leads/{id}/zoho"
  },
  {
    "key": "DELETE /api/v1/leads/{id}",
    "method": "DELETE",
    "route": "/api/v1/leads/{id}"
  },
  {
    "key": "GET /api/v1/notifications",
    "method": "GET",
    "route": "/api/v1/notifications"
  },
  {
    "key": "PATCH /api/v1/notifications/{id}/read",
    "method": "PATCH",
    "route": "/api/v1/notifications/{id}/read"
  },
  {
    "key": "POST /api/v1/notifications/read-all",
    "method": "POST",
    "route": "/api/v1/notifications/read-all"
  },
  {
    "key": "PATCH /api/v1/notifications/read-all",
    "method": "PATCH",
    "route": "/api/v1/notifications/read-all"
  },
  {
    "key": "DELETE /api/v1/notifications/{id}",
    "method": "DELETE",
    "route": "/api/v1/notifications/{id}"
  },
  {
    "key": "GET /api/v1/communications/messages",
    "method": "GET",
    "route": "/api/v1/communications/messages"
  },
  {
    "key": "GET /api/v1/communications/messages/{id}",
    "method": "GET",
    "route": "/api/v1/communications/messages/{id}"
  },
  {
    "key": "POST /api/v1/communications/messages/send",
    "method": "POST",
    "route": "/api/v1/communications/messages/send"
  },
  {
    "key": "POST /api/v1/communications/messages/{id}/summarise",
    "method": "POST",
    "route": "/api/v1/communications/messages/{id}/summarise"
  },
  {
    "key": "PATCH /api/v1/communications/messages/{id}/read",
    "method": "PATCH",
    "route": "/api/v1/communications/messages/{id}/read"
  },
  {
    "key": "PATCH /api/v1/communications/messages/read-all",
    "method": "PATCH",
    "route": "/api/v1/communications/messages/read-all"
  },
  {
    "key": "GET /api/v1/audit",
    "method": "GET",
    "route": "/api/v1/audit"
  },
  {
    "key": "GET /api/v1/audit/my-activity",
    "method": "GET",
    "route": "/api/v1/audit/my-activity"
  },
  {
    "key": "POST /api/v1/reports/generate",
    "method": "POST",
    "route": "/api/v1/reports/generate"
  },
  {
    "key": "GET /api/v1/reports",
    "method": "GET",
    "route": "/api/v1/reports"
  },
  {
    "key": "DELETE /api/v1/reports/{id}",
    "method": "DELETE",
    "route": "/api/v1/reports/{id}"
  },
  {
    "key": "POST /api/v1/agents/run",
    "method": "POST",
    "route": "/api/v1/agents/run"
  },
  {
    "key": "POST /api/v1/agents/stream",
    "method": "POST",
    "route": "/api/v1/agents/stream"
  },
  {
    "key": "GET /api/v1/agents/history",
    "method": "GET",
    "route": "/api/v1/agents/history"
  },
  {
    "key": "GET /api/v1/agents/prompts",
    "method": "GET",
    "route": "/api/v1/agents/prompts"
  },
  {
    "key": "POST /api/v1/agents/prompts",
    "method": "POST",
    "route": "/api/v1/agents/prompts"
  },
  {
    "key": "PATCH /api/v1/agents/prompts/{id}",
    "method": "PATCH",
    "route": "/api/v1/agents/prompts/{id}"
  },
  {
    "key": "GET /api/v1/agents/usage-stats",
    "method": "GET",
    "route": "/api/v1/agents/usage-stats"
  },
  {
    "key": "POST /api/v1/agents/runs/{id}/attach",
    "method": "POST",
    "route": "/api/v1/agents/runs/{id}/attach"
  },
  {
    "key": "GET /api/v1/company-research",
    "method": "GET",
    "route": "/api/v1/company-research"
  },
  {
    "key": "GET /api/v1/company-research/{id}",
    "method": "GET",
    "route": "/api/v1/company-research/{id}"
  },
  {
    "key": "POST /api/v1/company-research/deep-dive",
    "method": "POST",
    "route": "/api/v1/company-research/deep-dive"
  },
  {
    "key": "POST /api/v1/company-research/{id}/retry",
    "method": "POST",
    "route": "/api/v1/company-research/{id}/retry"
  },
  {
    "key": "POST /api/v1/company-research",
    "method": "POST",
    "route": "/api/v1/company-research"
  },
  {
    "key": "PATCH /api/v1/company-research/{id}",
    "method": "PATCH",
    "route": "/api/v1/company-research/{id}"
  },
  {
    "key": "GET /api/v1/criteria-requirements/analyses",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/analyses"
  },
  {
    "key": "POST /api/v1/criteria-requirements/analyses",
    "method": "POST",
    "route": "/api/v1/criteria-requirements/analyses"
  },
  {
    "key": "GET /api/v1/criteria-requirements/analyses/{id}",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/analyses/{id}"
  },
  {
    "key": "PATCH /api/v1/criteria-requirements/analyses/{id}",
    "method": "PATCH",
    "route": "/api/v1/criteria-requirements/analyses/{id}"
  },
  {
    "key": "DELETE /api/v1/criteria-requirements/analyses/{id}",
    "method": "DELETE",
    "route": "/api/v1/criteria-requirements/analyses/{id}"
  },
  {
    "key": "POST /api/v1/criteria-requirements/analyses/sharepoint-link",
    "method": "POST",
    "route": "/api/v1/criteria-requirements/analyses/sharepoint-link"
  },
  {
    "key": "POST /api/v1/criteria-requirements/analyses/sharepoint-file",
    "method": "POST",
    "route": "/api/v1/criteria-requirements/analyses/sharepoint-file"
  },
  {
    "key": "POST /api/v1/criteria-requirements/analyses/{id}/cancel",
    "method": "POST",
    "route": "/api/v1/criteria-requirements/analyses/{id}/cancel"
  },
  {
    "key": "GET /api/v1/criteria-requirements/onedrive/status",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/onedrive/status"
  },
  {
    "key": "GET /api/v1/criteria-requirements/onedrive/connect",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/onedrive/connect"
  },
  {
    "key": "GET /api/v1/criteria-requirements/onedrive/drives",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/onedrive/drives"
  },
  {
    "key": "GET /api/v1/criteria-requirements/onedrive/drives/{driveId}/children",
    "method": "GET",
    "route": "/api/v1/criteria-requirements/onedrive/drives/{driveId}/children"
  },
  {
    "key": "POST /api/v1/criteria-requirements/analyses/onedrive-file",
    "method": "POST",
    "route": "/api/v1/criteria-requirements/analyses/onedrive-file"
  },
  {
    "key": "DELETE /api/v1/company-research/{id}",
    "method": "DELETE",
    "route": "/api/v1/company-research/{id}"
  },
  {
    "key": "GET /api/v1/governance/evaluations",
    "method": "GET",
    "route": "/api/v1/governance/evaluations"
  },
  {
    "key": "POST /api/v1/governance/evaluations",
    "method": "POST",
    "route": "/api/v1/governance/evaluations"
  },
  {
    "key": "GET /api/v1/governance/evaluations/{id}",
    "method": "GET",
    "route": "/api/v1/governance/evaluations/{id}"
  },
  {
    "key": "PATCH /api/v1/governance/evaluations/{id}",
    "method": "PATCH",
    "route": "/api/v1/governance/evaluations/{id}"
  },
  {
    "key": "POST /api/v1/governance/evaluations/{id}/respond",
    "method": "POST",
    "route": "/api/v1/governance/evaluations/{id}/respond"
  },
  {
    "key": "POST /api/v1/governance/evaluations/{id}/generate-report",
    "method": "POST",
    "route": "/api/v1/governance/evaluations/{id}/generate-report"
  },
  {
    "key": "GET /api/v1/governance/training",
    "method": "GET",
    "route": "/api/v1/governance/training"
  },
  {
    "key": "POST /api/v1/governance/training",
    "method": "POST",
    "route": "/api/v1/governance/training"
  },
  {
    "key": "GET /api/v1/governance/training/{id}",
    "method": "GET",
    "route": "/api/v1/governance/training/{id}"
  },
  {
    "key": "PATCH /api/v1/governance/training/{id}",
    "method": "PATCH",
    "route": "/api/v1/governance/training/{id}"
  },
  {
    "key": "GET /api/v1/governance/skills-audit",
    "method": "GET",
    "route": "/api/v1/governance/skills-audit"
  },
  {
    "key": "POST /api/v1/governance/skills-audit",
    "method": "POST",
    "route": "/api/v1/governance/skills-audit"
  },
  {
    "key": "GET /api/v1/governance/skills-audit/{id}",
    "method": "GET",
    "route": "/api/v1/governance/skills-audit/{id}"
  },
  {
    "key": "PATCH /api/v1/governance/skills-audit/{id}",
    "method": "PATCH",
    "route": "/api/v1/governance/skills-audit/{id}"
  },
  {
    "key": "GET /api/v1/company-sec/meetings",
    "method": "GET",
    "route": "/api/v1/company-sec/meetings"
  },
  {
    "key": "POST /api/v1/company-sec/meetings",
    "method": "POST",
    "route": "/api/v1/company-sec/meetings"
  },
  {
    "key": "GET /api/v1/company-sec/meetings/{id}",
    "method": "GET",
    "route": "/api/v1/company-sec/meetings/{id}"
  },
  {
    "key": "PATCH /api/v1/company-sec/meetings/{id}",
    "method": "PATCH",
    "route": "/api/v1/company-sec/meetings/{id}"
  },
  {
    "key": "GET /api/v1/company-sec/minutes",
    "method": "GET",
    "route": "/api/v1/company-sec/minutes"
  },
  {
    "key": "POST /api/v1/company-sec/minutes",
    "method": "POST",
    "route": "/api/v1/company-sec/minutes"
  },
  {
    "key": "GET /api/v1/company-sec/minutes/{id}",
    "method": "GET",
    "route": "/api/v1/company-sec/minutes/{id}"
  },
  {
    "key": "PATCH /api/v1/company-sec/minutes/{id}",
    "method": "PATCH",
    "route": "/api/v1/company-sec/minutes/{id}"
  },
  {
    "key": "POST /api/v1/company-sec/minutes/{id}/approve",
    "method": "POST",
    "route": "/api/v1/company-sec/minutes/{id}/approve"
  },
  {
    "key": "GET /api/v1/company-sec/entities",
    "method": "GET",
    "route": "/api/v1/company-sec/entities"
  },
  {
    "key": "POST /api/v1/company-sec/entities",
    "method": "POST",
    "route": "/api/v1/company-sec/entities"
  },
  {
    "key": "GET /api/v1/company-sec/entities/{id}",
    "method": "GET",
    "route": "/api/v1/company-sec/entities/{id}"
  },
  {
    "key": "PATCH /api/v1/company-sec/entities/{id}",
    "method": "PATCH",
    "route": "/api/v1/company-sec/entities/{id}"
  },
  {
    "key": "GET /api/v1/company-sec/resolutions",
    "method": "GET",
    "route": "/api/v1/company-sec/resolutions"
  },
  {
    "key": "POST /api/v1/company-sec/resolutions",
    "method": "POST",
    "route": "/api/v1/company-sec/resolutions"
  },
  {
    "key": "PATCH /api/v1/company-sec/resolutions/{id}/vote",
    "method": "PATCH",
    "route": "/api/v1/company-sec/resolutions/{id}/vote"
  },
  {
    "key": "GET /api/v1/social-impact/projects",
    "method": "GET",
    "route": "/api/v1/social-impact/projects"
  },
  {
    "key": "POST /api/v1/social-impact/projects",
    "method": "POST",
    "route": "/api/v1/social-impact/projects"
  },
  {
    "key": "GET /api/v1/social-impact/projects/{id}",
    "method": "GET",
    "route": "/api/v1/social-impact/projects/{id}"
  },
  {
    "key": "PATCH /api/v1/social-impact/projects/{id}",
    "method": "PATCH",
    "route": "/api/v1/social-impact/projects/{id}"
  },
  {
    "key": "POST /api/v1/social-impact/projects/{id}/indicators",
    "method": "POST",
    "route": "/api/v1/social-impact/projects/{id}/indicators"
  },
  {
    "key": "GET /api/v1/social-impact/projects/{id}/data-points",
    "method": "GET",
    "route": "/api/v1/social-impact/projects/{id}/data-points"
  },
  {
    "key": "POST /api/v1/social-impact/projects/{id}/data-points",
    "method": "POST",
    "route": "/api/v1/social-impact/projects/{id}/data-points"
  },
  {
    "key": "PATCH /api/v1/social-impact/data-points/{id}/verify",
    "method": "PATCH",
    "route": "/api/v1/social-impact/data-points/{id}/verify"
  },
  {
    "key": "GET /api/v1/social-impact/projects/{id}/stats",
    "method": "GET",
    "route": "/api/v1/social-impact/projects/{id}/stats"
  },
  {
    "key": "GET /api/v1/integrations/microsoft/connect",
    "method": "GET",
    "route": "/api/v1/integrations/microsoft/connect"
  },
  {
    "key": "GET /api/v1/integrations/microsoft/system-email/connect",
    "method": "GET",
    "route": "/api/v1/integrations/microsoft/system-email/connect"
  },
  {
    "key": "DELETE /api/v1/integrations/microsoft/system-email",
    "method": "DELETE",
    "route": "/api/v1/integrations/microsoft/system-email"
  },
  {
    "key": "POST /api/v1/integrations/microsoft/test-email",
    "method": "POST",
    "route": "/api/v1/integrations/microsoft/test-email"
  },
  {
    "key": "GET /api/v1/integrations/microsoft/test-email/{jobId}",
    "method": "GET",
    "route": "/api/v1/integrations/microsoft/test-email/{jobId}"
  },
  {
    "key": "GET /api/v1/integrations/zoho/connect",
    "method": "GET",
    "route": "/api/v1/integrations/zoho/connect"
  },
  {
    "key": "GET /api/v1/integrations/health",
    "method": "GET",
    "route": "/api/v1/integrations/health"
  },
  {
    "key": "DELETE /api/v1/integrations/{provider}/disconnect",
    "method": "DELETE",
    "route": "/api/v1/integrations/{provider}/disconnect"
  },
  {
    "key": "POST /api/v1/webhooks/whatsapp",
    "method": "POST",
    "route": "/api/v1/webhooks/whatsapp"
  },
  {
    "key": "POST /api/v1/webhooks/microsoft",
    "method": "POST",
    "route": "/api/v1/webhooks/microsoft"
  },
  {
    "key": "POST /api/v1/webhooks/zoho",
    "method": "POST",
    "route": "/api/v1/webhooks/zoho"
  },
  {
    "key": "GET /api/v1/admin/stats",
    "method": "GET",
    "route": "/api/v1/admin/stats"
  },
  {
    "key": "GET /api/v1/admin/ai-provider",
    "method": "GET",
    "route": "/api/v1/admin/ai-provider"
  },
  {
    "key": "PATCH /api/v1/admin/ai-provider",
    "method": "PATCH",
    "route": "/api/v1/admin/ai-provider"
  },
  {
    "key": "GET /api/v1/admin/users",
    "method": "GET",
    "route": "/api/v1/admin/users"
  },
  {
    "key": "PATCH /api/v1/admin/organization",
    "method": "PATCH",
    "route": "/api/v1/admin/organization"
  },
  {
    "key": "POST /api/v1/admin/organization/company-knowledge",
    "method": "POST",
    "route": "/api/v1/admin/organization/company-knowledge"
  },
  {
    "key": "POST /api/v1/admin/users/{id}/unlock",
    "method": "POST",
    "route": "/api/v1/admin/users/{id}/unlock"
  },
  {
    "key": "POST /api/v1/admin/users/invite",
    "method": "POST",
    "route": "/api/v1/admin/users/invite"
  },
  {
    "key": "PATCH /api/v1/admin/users/{id}",
    "method": "PATCH",
    "route": "/api/v1/admin/users/{id}"
  }
] as const;

export type OpenApiOperationKey = typeof openApiOperations[number]['key'];
export type OpenApiMethod = typeof openApiOperations[number]['method'];
export type OpenApiRoute = typeof openApiOperations[number]['route'];

export const openApiSchemaNames = [
  "AIProviderOverrideRequest",
  "AIProviderSettingsData",
  "AcceptInvitationRequest",
  "AccessTokenData",
  "AgentRun",
  "AssignedUserSummary",
  "AuditLog",
  "AuthUrlData",
  "BoardEvaluation",
  "BoardMeeting",
  "BoardTraining",
  "BooleanResult",
  "CompanyResearch",
  "ContactInfo",
  "CountResult",
  "CrawlerStatus",
  "CriteriaRequirementsAnalysis",
  "CsrfTokenData",
  "DashboardGridData",
  "DashboardTourData",
  "DeletedCountData",
  "DeletedNotificationsData",
  "DigestSettingsData",
  "DraftAnswer",
  "EmailTestQueued",
  "EmailTestStatus",
  "Entity",
  "EventAssignedUserReference",
  "EventDiscoveryRun",
  "EventIntelligenceProfile",
  "EventOpportunity",
  "EventOpportunityCreateRequest",
  "EventOpportunityStatus",
  "EventOpportunitySummary",
  "EventOpportunityType",
  "EventOpportunityUpdateRequest",
  "EventProfileFields",
  "EventProfileLink",
  "EventProfileReference",
  "EventProfileUpdateRequest",
  "EventProfileWriteRequest",
  "EventTeamMember",
  "EvidenceAssessment",
  "EvidenceDocument",
  "EvidenceDocumentUpdateRequest",
  "EvidenceLeadResults",
  "EvidenceMatch",
  "EvidenceRepository",
  "EvidenceRepositoryCreateRequest",
  "EvidenceRepositoryJobData",
  "EvidenceRepositoryUpdateRequest",
  "EvidenceRunData",
  "EvidenceScoreOverrideRequest",
  "ExpertAssessment",
  "ExpertCompareRequest",
  "ExpertGovernanceUpdateRequest",
  "ExpertProfile",
  "ExpertRecommendation",
  "ExpertRecommendationWithProfile",
  "ExpertRejectionRequest",
  "ExpertRequirement",
  "ExpertRequirementMatrixItem",
  "ExpertResults",
  "ExpertRoleResults",
  "ExpertRunData",
  "ExpertSelection",
  "ExpertSelectionRequest",
  "ExpertSelectionUpdateRequest",
  "ExpertTeamMember",
  "ExpertTeamResponse",
  "IntegrationHealth",
  "InvitationCodeData",
  "JobData",
  "LeadActivity",
  "LeadDetail",
  "LeadSummary",
  "LoginData",
  "LoginRequest",
  "ManualEvidenceMatchRequest",
  "MatchingScopeRequest",
  "MealDataPoint",
  "MealProject",
  "Message",
  "MfaDisabledData",
  "MfaEnabledData",
  "MfaSetupData",
  "MicrosoftOAuthUrl",
  "MicrosoftOneDriveStatus",
  "Minutes",
  "Notification",
  "NullData",
  "OrganizationDetail",
  "OrganizationSummary",
  "PaginationMeta",
  "PasswordChangedData",
  "PendingTenantInvitation",
  "ProductUpdatesData",
  "ProductUpdatesRequest",
  "PromptTemplate",
  "ProposalComplianceUpdateRequest",
  "ProposalDraft",
  "ProposalDraftCreateRequest",
  "ProposalSectionUpdateRequest",
  "ReceivedData",
  "RefreshSessionSummary",
  "Report",
  "Resolution",
  "SharePointDrive",
  "SkillsAudit",
  "SourcePreviewData",
  "Statistics",
  "StringArray",
  "TenantInvitationData",
  "TenantInvitationRequest",
  "TenderDetail",
  "TenderDocument",
  "TenderExpertRole",
  "TenderMatchRun",
  "TenderRequirement",
  "TenderSummary",
  "TimelineTask",
  "UserDocument",
  "UserNameData",
  "UserPreferences",
  "UserProfile",
  "UserRole",
  "UserSummary",
  "properties"
] as const;

export type OpenApiSchemaName = typeof openApiSchemaNames[number];
